import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './PartnerGameItem.module.scss';
import clsx from 'clsx';
import { imageUrl } from '../../utils/imageUrl';
import Swal from 'sweetalert2';
import { gamePartnerSwitchActive } from '../../redux/actions/game/gamePartnerSwitchActive';
import { gamePartnerList } from '../../redux/actions/game/gamePartnerList';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Input from '../Input/Input';
import { Tooltip } from 'react-tooltip';
import { gamePartnerUpdate } from '../../redux/actions/game/gamePartnerUpdate';
import { gamePartnerDelete } from '../../redux/actions/game/gamePartnerDelete';
import { useMediaQuery } from '../../utils/useMediaQuery';
const PartnerGameItem = ({ id, active, innerId, logo, isLast, game, percent }) => {
  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const form = useForm({ defaultValues: { percent, innerId } });
  const {
    gamePartnerSwitchActive: { data: gamePartnerSwitchActiveData, loading: gamePartnerSwitchActiveLoading, error: gamePartnerSwitchActiveError },

    gamePartnerUpdate: { data: gamePartnerUpdateData, loading: gamePartnerUpdateLoading, error: gamePartnerUpdateError },
    gamePartnerDelete: { data: gamePartnerDeleteData, loading: gamePartnerDeleteLoading, error: gamePartnerDeleteError },
  } = useSelector((state) => state.game);

  const onEdit = () => {
    form.setValue('innerId', innerId);
    form.setValue('percent', percent);
    setIsEdit(true);
  };
  const onCancel = () => {
    setIsEdit(false);
  };

  const onDelete = () => {
    Swal.fire({
      title: `Вы уверены что хотите удалить игру`,
      showCancelButton: true,
      showConfirmButton: true,
      background: '#fff',
      cancelButtonColor: '#fc564a',
      cancelButtonText: 'Отмена',
      confirmButtonColor: '#65c15c',
      confirmButtonText: 'Удалить',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(gamePartnerDelete({ serviceGameId: id }));
      }
    });
  };

  const onSwitchActive = () => {
    Swal.fire({
      title: `Вы уверены что хотите ${active ? 'отключить' : 'включить'} игру`,
      showCancelButton: true,
      showConfirmButton: true,
      background: '#fff',
      cancelButtonColor: '#fc564a',
      cancelButtonText: 'Отмена',
      confirmButtonColor: '#65c15c',
      confirmButtonText: active ? 'Отключить' : 'Включить',
    }).then((data) => {
      if (data.isConfirmed) {
        dispatch(gamePartnerSwitchActive({ serviceGameId: id }));
      }
    });
  };
  const onSave = (data) => {
    Swal.fire({
      title: `Вы уверены что хотите обновить данные игры`,
      showCancelButton: true,
      showConfirmButton: true,
      background: '#fff',
      cancelButtonColor: '#fc564a',
      cancelButtonText: 'Отмена',
      confirmButtonColor: '#65c15c',
      confirmButtonText: 'Обновить',
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(gamePartnerUpdate({ serviceGameId: id, ...data }));
      }
    });
  };
  useEffect(() => {
    if (gamePartnerSwitchActiveData) {
      dispatch(gamePartnerList());
    }
  }, [gamePartnerSwitchActiveData]);
  useEffect(() => {
    if (gamePartnerUpdateData) {
      dispatch(gamePartnerList());
      setIsEdit(false);
    }
  }, [gamePartnerUpdateData]);

  useEffect(() => {
    if (gamePartnerDeleteData) {
      dispatch(gamePartnerList());
    }
  }, [gamePartnerDeleteData]);
  const isMobile = useMediaQuery('(max-width:840px)');
  const cellPercent = () => {
    return <div className={clsx(styles.cell, styles.cellPercent)}>{isEdit ? <Input showError={false} type={'number'} className={clsx(styles.inputPercent)} name="percent" form={form} label="% скидки" suffix={'%'} /> : <div className={clsx(styles.percent)}>{percent} %</div>}</div>;
  };
  return (
    <>
      <div className={clsx(styles.cell, styles.cellGameId)}>{isEdit ? <Input showError={false} type={'text'} className={clsx(styles.inputGameId)} name="innerId" form={form} label="ID игры" /> : `ID ${innerId}`} </div>
      <div className={clsx(styles.cell)}>
        <img src={imageUrl(game?.logo)} alt="" className={clsx(styles.logo)} />
      </div>
      <div className={clsx(styles.cell)}>
        <div className={clsx(styles.name)}>{game?.name}</div>
      </div>
      {!isMobile && cellPercent()}
      <div className={clsx(styles.cell)}>
        <div className={clsx(styles.status, active ? styles.statusActive : styles.statusDisable)}>{active ? 'Активно' : 'Неактивно'}</div>
      </div>
      <div className={clsx(styles.cell)}>
        {isEdit ? (
          <div></div>
        ) : (
          <div
            data-tooltip-id="tooltip"
            data-tooltip-content="Выключить"
            className={clsx(styles.icon, active ? styles.active : styles.disable)}
            onClick={() => {
              onSwitchActive();
            }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-power">
              <path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path>
              <line x1="12" y1="2" x2="12" y2="12"></line>
            </svg>
          </div>
        )}
      </div>{' '}
      <div className={clsx(styles.cell)}>
        {isEdit ? (
          <div className={clsx(styles.icon, styles.edit)} onClick={form.handleSubmit(onSave)} data-tooltip-id="tooltip" data-tooltip-content="Cохранить">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-save">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path>
              <polyline points="17 21 17 13 7 13 7 21"></polyline>
              <polyline points="7 3 7 8 15 8"></polyline>
            </svg>
          </div>
        ) : (
          <div className={clsx(styles.icon, styles.edit)} onClick={onEdit} data-tooltip-id="tooltip" data-tooltip-content="Редактировать">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit-2">
              <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
            </svg>
          </div>
        )}
      </div>
      <div className={clsx(styles.cell)}>
        {isEdit ? (
          <div className={clsx(styles.icon, styles.delete)} data-tooltip-id="tooltip" data-tooltip-content="Отмена" onClick={onCancel}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </div>
        ) : (
          <div className={clsx(styles.icon, styles.delete)} data-tooltip-id="tooltip" data-tooltip-content="Удалить" onClick={onDelete}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-trash">
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
            </svg>
          </div>
        )}
      </div>
      {isMobile && cellPercent()}
      {!isLast && <div className={clsx(styles.divider)}></div>}
    </>
  );
};

export default PartnerGameItem;
